import { ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { BrowserRouter, Switch } from 'react-router-dom'
import { CompatRouter, Routes, CompatRoute, Route } from "react-router-dom-v5-compat";
import { useInterval } from 'react-interval-hook'
import zhCN from 'antd/lib/locale/zh_CN'
import enUS from 'antd/lib/locale/en_US'
import FrontendAuth from './config/frontendAuth'
import Main from './config/main'
import './App.css'
import { useAppSelector } from './redux/reduxHooks'
import { homePageData } from './redux/reducers/homePage_reducer'
import { refreshToken } from './api/response'
import CashBoxHistoryPage from './pages/cashBoxHistory';
import Order from './pages/orderHistory'
import PaymentMethods from './pages/paymentProcess';
import Print from './pages/print';
import ReportList from './pages/reportList';
import Account from './pages/account';
import CashBoxHistory from './pages/cashBoxHistory';
import CashBoxListPage from './pages/cashBoxList';
import CouponHistory from './pages/couponHistory';
import CreditHistory from './pages/creditHistory';
import Customers from './pages/customerCenter';
import Index from './pages/index';
import Login from './pages/login';
import NotFound from './pages/notFound';
import PaymentHistory from './pages/paymentHistory';
import paymentSuccess from './pages/paymentSuccess';
// import PlaceOrder from './pages/placeorder';
import PointHistory from './pages/pointHistory';
import PaymentSuccess from './components/payment/paymentSuccess';
import Coupon from './components/couponList';

dayjs.locale('zh-cn')
function App() {
  const storeState = useAppSelector(homePageData)
  const { start, stop, isActive } = useInterval(
    () => {
      const tokenRefresh = localStorage.getItem('refreshToken')
      const tokenExpireAt = Number(localStorage.getItem('tokenExpireAt'))
      if (tokenRefresh) {
        const expiredAt = dayjs(tokenExpireAt)
        console.log(expiredAt.format('HH:mm:ss') + ' left:' + expiredAt.diff(dayjs(), 'second'))
        if (dayjs().add(180, 'second') > dayjs(tokenExpireAt)) {
          refreshToken({ refreshToken: tokenRefresh }).then((res) => {
            console.log('refresh token')
            if (res.success) {
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('refreshToken', res.data.refreshToken)
              localStorage.setItem('tokenExpireAt', dayjs().add(res.data.expireTime, 'second') + '')
            } else {
              localStorage.removeItem('token')
              localStorage.removeItem("refreshToken")
              localStorage.removeItem('tokenExpireAt')
              console.log('refresh token failed: ' + res.message)
            }
          })
        }
      } else {
        console.log('refresh token is null')
      }
    },
    10000,
    {
      autoStart: true,
      immediate: false,
      onFinish: () => {
        console.log('Timer is stopped');
      }
    }
  )

  return (
    <BrowserRouter>
      <CompatRouter>
        <ConfigProvider
          locale={storeState.lang === 'zh-CN' ? (localStorage.getItem('lang') === 'zh-CN' ? zhCN : enUS) : enUS}
          theme={{
            token: {
              colorPrimary: '#ffa500',
              colorLink: '#ffa500',
              colorIcon: '#ffa500',
              //ipad screen 1024x738 -> 1366
              screenMD: 900,
              screenMDMin: 900,
              screenMDMax: 1366,
              //laptop 1440
              screenLG: 1367,
              screenLGMin: 1367,
              screenLGMax: 1440,
              //desktop 1440=>
              screenXL: 1441,
              screenXLMin: 1441,
              screenXLMax: 1920,
              // 4k desktop
              screenXXL: 1921,
              screenXXLMin: 1921
            }
          }}
        >
          <Main>
            <Switch>
              <CompatRoute path='/' component={Index} exact />
              <CompatRoute path='/settings/account' component={Account} exact />
              <CompatRoute path='/login' component={Login} />
              <CompatRoute path='/order' component={Order} exact />
              <CompatRoute path='/order/:id' component={Order} exact />
              <CompatRoute path='/customers' component={Customers} exact />
              {/* <CompatRoute path='/placeorder' component={PlaceOrder} exact /> */}
              <CompatRoute path='/placeOrder/paymentSuccess' component={PaymentSuccess} exact />
              <CompatRoute path='/pointHistory' component={PointHistory} exact />
              <CompatRoute path='/creditHistory' component={CreditHistory} exact />
              <CompatRoute path='/paymentHistory' component={PaymentHistory} exact />
              <CompatRoute path='/coupon' component={CouponHistory} exact />
              <CompatRoute path='/cashBoxList' component={CashBoxListPage} exact />
              <CompatRoute path='/404' component={NotFound} exact />
              <CompatRoute path='/order/:id/dispatch' component={Order} exact />
              <CompatRoute path='/payment/:id' component={PaymentMethods} exact />
              <CompatRoute path='/report/:type' component={ReportList} exact />
              <CompatRoute path='/print/:id' component={Print} exact />
              <CompatRoute path='/cashBoxList/:id' component={CashBoxHistoryPage} exact />
            </Switch>
          </Main>
        </ConfigProvider>
      </CompatRouter>
    </BrowserRouter>
  )
}

export default App
